export const IMPERSONATED_CLIENT_COOKIE = "impersonatedClient";
export const JWT_RENT_COOKIE = "jwtRent";
export const REFRESH_TOKEN_RENT_COOKIE = "refreshTokenRent";
export const EXPIRES_IN_RENT_COOKIE = "expiresInRent";
export const AUTH_ACTION = "auth";

// COOKIES KEYS
export const PROJECT_NAME_COOKIE_KEY = "projectName";
export const PROJECT_ID_COOKIE_KEY = "project_id";
export const JWT_TOKEN_COOKIE_KEY = "jwt";
export const REFRESH_TOKEN_COOKIE_KEY = "refreshToken";
export const EXPIRES_IN_COOKIE_KEY = "expiresIn";
export const VENDOR_ID_COOKIE_KEY = "vendorId";
export const USER_LANGUAGE_COOKIE_KEY = "userLanguage";
